import React from 'react';
import {
  AspectRatioCard,
  AspectRatioCardImage,
  AspectRatioCardTitle,
  AspectRatioCardText
} from '@homeaway/react-aspect-ratio-card';

const CNAME = 'Trending';

const TrendingCard = ({
  onClick,
  slpUrl,
  serpUrl,
  imageUrl,
  location,
  name,
  cardAspectRatio
}) => (
  <a
    href={slpUrl || serpUrl}
    className={`${CNAME}__link`}
    onClick={onClick}
  >
    <AspectRatioCard aspectRatio={cardAspectRatio}>
      <AspectRatioCardImage data-slot={'figure'} imageUri={imageUrl.replace('${templateId}', 'hw6')} />
      <AspectRatioCardTitle data-slot={'caption'} title={name} />
      <div className={`${CNAME}__content`} data-slot={'content'}>
        <AspectRatioCardText text={location} />

      </div>
    </AspectRatioCard>
  </a>
);

TrendingCard.defaultProps = {
  cardAspectRatio: '4x3'
};

export default TrendingCard;



// WEBPACK FOOTER //
// ./src/universal/components/Trending/TrendingCard.js